<template>
	<div class="dialog_scroll clearfix">
		<div class="taskIng_left">
			<div class="taskIng_infoHead" v-show="questionindex == index" v-for="(item,index) in qusetionlist">
				<img src="@/images/topic_type1.png" v-if="item.topicType == 1" />
				<img src="@/images/topic_type2.png" v-if="item.topicType == 2" />
				<img src="@/images/topic_type3.png" v-if="item.topicType == 3" />
				<img src="@/images/topic_type4.png" v-if="item.topicType == 4" />
				<img src="@/images/topic_type5.png" v-if="item.topicType == 5" />
			</div>
			<div class="taskQuestion_infobody clearfix">
				<questions @singleAnswer='({it,i,index})=>{singleAnswer(it,i,index)}' @multipleAnswer='({it,i,index})=>{multipleAnswer(it,i,index)}' @blanksAnswer='({index})=>{blanksAnswer(index)}' @uploadStatus="(newuploadFlag)=>{uploadFlag = newuploadFlag}" @uploadAnswer='uploadAnswer' @formFileRemove='formFileRemove' :taskType='false' :questionsubmit='false' :qusetionlist='qusetionlist' :questionindex='questionindex'></questions>
			</div>
			<div class="taskIng_infoFoot">
				<el-button @click="jumpQuestion(questionindex-1,'prve')" :disabled='questionindex<=0 || uploadFlag'>上一题</el-button>
				<el-button @click="jumpQuestion(questionindex+1,'next')" type="primary" :disabled='questionindex>=qusetionlist.length-1 || uploadFlag'>下一题</el-button>
			</div>
		</div>
		<div class="taskIng_right">
			<div class="taskIng_rightHead">出错次数：{{viewItem.errorCount}}次</div>
			<div class="examIng_infobody clearfix">
				<div class="questionAnswer" :class="questionErrorStatus(item,index)" v-for="(item,index) in qusetionlist" @click="jumpQuestion(index,'jump')">
					{{index+1}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { topiclist, getUserTaskErrorTopic, getUserErrorInfo, getUserExamErrorTopic, getUserExamErrorInfo, getUserErrorTopic, getExperErrorInfo, getUserSeltTestTopic, getUserSeltTestTopicDetail } from '@/api/topic.js'
	import questions from '@/components/questions.vue'
	import questionsjs from '@/components/questions.js'
	export default {
		mixins: [questionsjs],
		components: {
			questions
		},
		props: {
			viewItem: Object,
			viewCheck: String,
		},
		data() {
			return {
				uploadFlag: false,
				questionindex: 0,
				questionove: [],
				qusetionlist: [],
			}
		},
		created() {
			this.getTaskinfo();
		},
		methods: {
			getTaskinfo() {
				var check = this.viewCheck;
				var item = this.viewItem;
				var data = {
					topicId: this.viewItem.topicId,
					type: this.viewItem.type,
				}
				if(check == 'task') {
					getUserErrorInfo(data).then(res => {
						if(res.code == "OK" && res.data.length > 0) {
							this.openView(item, res.data)
						}
					})
				}
				if(check == 'exam') {
					getUserExamErrorInfo(data).then(res => {
						if(res.code == "OK" && res.data.length > 0) {
							this.openView(item, res.data)
						}
					})
				}
				if(check == 'exper') {
					getExperErrorInfo(data).then(res => {
						if(res.code == "OK" && res.data.length > 0) {
							this.openView(item, res.data)
						}
					})
				}
			},
			openView(item, listData) {
				var qusetionlist = [];
				listData.map(it => {
					var question = Object.assign({}, item);
					question.userAnswer = it.userAnswer;
					if(question.topicType != 4 && question.topicType != 5) {
						if(!it.userAnswer) {
							question.choose = [];
						} else {
							question.choose = it.userAnswer.split('')
						}
					}
					qusetionlist.push(question);
				})
				this.qusetionlist = qusetionlist;
				this.formInitOver();
			},
			questionWhere(index) {
				var questionindex = this.questionindex;
				var questionove = this.questionove;
				if(index == questionindex) {
					return 'questionAnswer doing'
				} else if(questionove.indexOf(index) != -1) {
					return 'questionAnswer over'
				} else {
					return 'questionAnswer'
				}
			},
			jumpQuestion(questionindex) {
				if(this.questionindex != questionindex) {
					this.questionindex = questionindex
				}
			},
			toName(name) {
				if(this.$route.name != name) {
					this.$router.push({
						name
					})
				}
			},
		},
	}
</script>